import styled from '@emotion/styled';
export type Layout = 'spaced-list' | 'list';

export const StyledTagList = styled.dl<{ layout: Layout }>(({ theme, layout }) => ({
    display: 'flex',
    gap: theme.spaces[layout === 'list' ? 1 : 2],
    flexWrap: 'wrap',
}));
